var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('registration-code-edit-create',{attrs:{"organization-id":_vm.$auth.me.organization_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }